import React from 'react'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'strike' | 'outlined';
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    fullWidthOnMobile?: boolean;
    height?: number;
}

const PrimaryButton = (props: Props) => {
    const {
        startIcon: startIcon,
        endIcon: endIcon,
        fullWidthOnMobile: fullWidthOn,
        height: height,
        ...buttonProps
    } = props
    const variant = props.variant || 'primary';
    function getColorClassNames() {
        switch (variant) {
            case 'primary':
                return 'bg-primary-dark border-solid border-primary-dark border-[1px] text-white hover:bg-primary disabled:bg-primary disabled:opacity-40 disabled:cursor-not-allowed';
            case 'secondary':
                return 'bg-neutral-deep border-solid border-neutral-deep border-[1px] text-primary-dark hover:bg-neutral disabled:bg-neutral-light disabled:opacity-50 disabled:cursor-not-allowed';
            case 'strike':
                return 'bg-strike text-white border-solid border-solid border-strike border-[1px] hover:bg-strike-light disabled:bg-strike-dark disabled:opacity-50 disabled:cursor-not-allowed';
            case 'outlined':
                return 'bg-slate-100 text-primary-dark border border-primary-dark hover:bg-slate-300 disabled:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed';
            default:
                return 'bg-primary-dark text-white';
        }
    }

    function leftPadding() {
        if (!props.startIcon) {
            return 'pl-[24px]'
        }
        return 'pl-[12px]'
    }

    function rightPadding() {
        if (!props.endIcon) {
            return 'pr-[24px]'
        }
        return 'pr-[12px]'
    }

    return (
        <button
            {...buttonProps}
            className={`${leftPadding()} ${rightPadding()} ${props.fullWidthOnMobile ? 'w-full' : ''} box-border h-[${props.height || 44}px] md:w-fit text-[16px] font-bold rounded-[12px] transition-all ${getColorClassNames()} ${props.className ?? ''}`}
            disabled={props.disabled}
        >
            <div className="flex gap-1 h-full">
                {props.startIcon && (<div className="h-full flex justify-center items-center">
                    <div>
                        {props.startIcon}
                    </div>
                </div>)}
                <div className={`${props.fullWidthOnMobile ? 'w-full text-center md:w-fit' : ''} h-full flex justify-center items-center leading-[16px]`}>
                    {props.children}
                </div>
                {props.endIcon && (<div className="h-full flex justify-center items-center">
                    {props.endIcon}
                </div>)}
            </div>
        </button>
    )
}

export default PrimaryButton